'use client'

import { Add } from '@mui/icons-material'
import { Section, Query, ListLocations, GridList } from '@wolfdanepug/common-react'
import AddressCard from '../../../components/address/AddressCard'
import { useContext, useEffect } from 'react'
import { PageContext } from '../../../context/page'

export const revalidate = 0

export default function Page() {
	const { setPage } = useContext(PageContext)

	useEffect(() => {
		setPage({
			title: 'Addresses',
			description: 'Manage your addresses',
			actions: [
				{
					label: 'Add Address',
					link: '/settings/addresses/new',
					icon: <Add />
				}
			],
			canGoBack: '/settings'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Section>
				<Query
					doc={ListLocations}
					component={GridList}
					componentProps={{
						spacing: 2,
						itemsPerRow: 3,
						component: AddressCard
					}}
				/>
			</Section>
		</>
	)
}
